// === AGENCE INK ENVIRONMENT TAGS === //
/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

////////////////////////// GSAP animation modules importation ////////////////////////////////
import gsap from "gsap";
//////////////////////////////////////////////////////////////////////////////////////////////

export const envTags = () => {
    let tag = document.querySelector('.envTag');
    if (tag) {
        // Move the tag on click
        let tagAnim = {
            start: {
                bottom: '7%',
                ease: 'bounce.out', 
                duration: '1.8'
            }, end: {
                bottom: "85%",
                ease: 'elastic.out(.33, .07)',
                duration: '1.66'
            }
        };

        let current = tagAnim.start;
        tag.addEventListener('click', () => {
            current = (current == tagAnim.start) ? tagAnim.end : tagAnim.start;
            gsap.to(tag, current);
        }); 
    }

    return;
};